export enum PanelRequestStatus {
  PENDING = "PENDING",
  FORWARDED = "FORWARDED",
  DONE = "DONE",
}

export enum IresDeviceRequestType {
  START_PROGRAM = "START_PROGRAM",
  STOP_PROGRAM = "STOP_PROGRAM",
  SELECT_PROGRAM = "SELECT_PROGRAM",
  READ_PROGRAM = "READ_PROGRAM",
  RESTART = "RESTART",
  IOT_CONFIG = "IOT_CONFIG",
  LOAD_RUNS = "LOAD_RUNS",

  COM_BOX_POWER_ON = "COM_BOX_POWER_ON",
  COM_BOX_POWER_OFF = "COM_BOX_POWER_OFF",
  COM_BOX_START_DRY_RUN = "COM_BOX_START_DRY_RUN",
  COM_BOX_CHANGE_DRY_RUN = "COM_BOX_CHANGE_DRY_RUN",
  COM_BOX_PAUSE = "COM_BOX_PAUSE",
  COM_BOX_TEST_RELAYS = "COM_BOX_TEST_RELAYS",
  COM_BOX_RESUME = "COM_BOX_RESUME",
  COM_BOX_TERMINATE_DRY_RUN = "COM_BOX_TERMINATE_DRY_RUN",

  COM_BOX_SWITCH_TO_IDLE = "COM_BOX_SWITCH_TO_IDLE",
  COM_BOX_RESET = "COM_BOX_RESET",
  COM_BOX_DELETE_SAMPLES = "COM_BOX_DELETE_SAMPLES",

  COM_BOX_GET_BASE_CONFIG = "COM_BOX_GET_BASE_CONFIG",
  COM_BOX_GET_CLIENT_CONFIG = "COM_BOX_GET_CLIENT_CONFIG",
}

export interface IresDeviceRequest {
  requestId: string;
  priority: number;
  canBeObserved: boolean;
  panelId: string;
  payload: string;
  requestStatus: PanelRequestStatus;
  forwardImmediately: boolean;
  requestType?: IresDeviceRequestType;
  createdAt: Date;
}
